export default function Confusion_Matrix() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Confusion_Matrix</h1>
      <p>Content for Confusion_Matrix goes here.</p>
    </div>
  );
}